











































































import { mapGetters } from 'vuex';

export default {
	name: 'TopNav',

	computed: {
		...mapGetters('notifications/notification', {
			unreadNotifications: 'getUnreadBoolean',
		}),

		...mapGetters({
			universityTheme: 'getUniversityTheme',
			theme: 'getTheme',
		}),

		userInitials() {
			return this.$auth.loggedIn
				? `${this.$auth.user.name[0]}${this.$auth.user.surname[0]}`
				: '';
		},
	},

	methods: {
		navToNotifications() {
			this.$router.push(this.localePath({ name: 'notifications' }));
		},

		navToMessages() {
			this.$router.push(this.localePath({ name: 'messages' }));
		},

		navToHome() {
			this.$router.push({ path: '/' });
		},
	},
};
